import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";
import NProgress from "nprogress";
Vue.use(VueRouter);
var list = ["/orderInfo"];
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/weicangPlus",
    name: "WeicangPlus",
    component: () => import("../views/weicangPlus.vue")
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue")
  },
  {
    path: "/qrCode",
    name: "qrCode",
    component: () => import("../views/qrCode.vue")
  },
  {
    path: "/X5Details",
    name: "X5Details",
    component: () => import("../views/X5/X5Details.vue")
  },
  {
    path: "/buy",
    name: "buy",
    component: () => import("../views/buy.vue")
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("../views/pay/pay.vue")
  },
  {
    path: "/submitOrder",
    name: "submitOrder",
    component: () => import("../views/submitOrder/index.vue")
  },
  {
    path: "/success",
    name: "success",
    component: () => import("../views/pay/success.vue")
  },
  {
    path: "/orderInfo",
    name: "orderInfo",
    component: () => import("../views/order/orderInfo.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue")
  },
  {
    path: "/createAccount",
    name: "createAccount",
    component: () => import("../views/account/createAccount.vue")
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () => import("../views/account/forgetPassword.vue")
  },
  {
    path: "/editMobilePhone",
    name: "editMobilePhone",
    component: () => import("../views/mobile_account/editMobilePhone.vue")
  },
  {
    path: "/editPassword",
    name: "editPassword",
    component: () => import("../views/mobile_account/editPassword.vue")
  },
  {
    path: "/editBaseInfo",
    name: "editBaseInfo",
    component: () => import("../views/mobile_account/editBaseInfo.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  let pathList = ["/buy", "/submitOrder"];

  NProgress.start();
  if (pathList.indexOf(to.path) == -1) {
    store.commit("edit_showTop", true);
  } else {
    store.commit("edit_showTop", false);
  }
  if (!store.state.user && list.indexOf(to.path) !== -1) {
    next("/login");
  }
  next();
});
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  NProgress.done();
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
export default router;
